import React from 'react';
import {Routes, Route } from 'react-router-dom'
import {Banner} from './Banner.js'
import {Navigation} from './Navigation.js'
import {News} from './News.js'
import {DRP} from './DRP.js'
import {Construction} from './Construction.js'
import {Footer} from './Footer.js'
import '../css/index.css';

function App() {
  return (
    <>
    <Banner/>
     <h1>Statistics & Probability Association </h1>
     <Navigation/>
     <Routes>
        <Route path="/" element={<News/>} />
        <Route path="spadrp" element={<DRP/>} />
        <Route path="*" element={<Construction/>}/>
     </Routes>
     <Footer/>
    </>
  );
}

export default App;
